import { useState } from 'react';
import { FormHeader } from 'src/pages/Reporting/Forms/FormHeader';
import Button from 'src/components/Button';
import { Multiselect } from 'multiselect-react-dropdown';
import { IProperty } from 'src/pages/Reporting/ReportingFormTypes';

export interface SelectedProperty {
  id?: string;
  name?: string;
}

interface OccupancyDeficiencyFormProps {
  properties: IProperty[];
  onGenerateReport: (
    propertyId?: string,
    includeProjectSummary?: boolean
  ) => void;
  selectedProperties: SelectedProperty[];
  updateSelectedProperties: (selectedList: SelectedProperty[]) => void;
}

export const OccupancyDeficiencyForm = ({
  properties,
  onGenerateReport,
  selectedProperties,
  updateSelectedProperties,
}: OccupancyDeficiencyFormProps) => {
  const onSelect = (selectedList: SelectedProperty[]): void => {
    updateSelectedProperties(selectedList);
  };

  const onRemove = (selectedList: SelectedProperty[]): void => {
    updateSelectedProperties(selectedList);
  };

  // If a property is selected, use its ID, otherwise pass undefined for "all properties"
  const handleGenerateReport = () => {
    const propertyId: string =
      selectedProperties.length > 0 ? selectedProperties[0].id : undefined;
    onGenerateReport(propertyId);
  };

  return (
    <div>
      <h4>Select Report Parameters</h4>
      <FormHeader>Property</FormHeader>
      <Multiselect
        options={properties.map((property: IProperty) => ({
          name: property.name,
          id: property.id,
        }))}
        displayValue="name"
        selectedValues={selectedProperties}
        placeholder="Select Property"
        onSelect={onSelect}
        onRemove={onRemove}
      />
      <div style={{ marginTop: '20px' }}>
        <Button
          color="teal"
          size="small"
          label="Generate Report"
          onClick={handleGenerateReport}
          disabled={selectedProperties.length === 0}
        />
      </div>
    </div>
  );
};
